import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useContext as useContextParent } from '../Context'
import { humanize, truncate } from '@ztechapps/common.utils'
import type { ListField } from '@ztechapps/common.hook'
import { useSearchInputContext } from './Context'
import { Icon } from '@ztechapps/webui.util'

const getDisplayName = (activeSearchField: ListField) => {
  const { displayName, name } = activeSearchField ?? {}

  let result = displayName
  if (!displayName) result = humanize(name ?? '')

  return result
}

export const SearchFieldsDropdown = () => {
  const { searchField, loading } = useContextParent()
  const { search, displaySearchFields } = useSearchInputContext()

  const onMenuClick = (field: ListField) => {
    search(field)
  }
  const title = truncate(getDisplayName(searchField), 13)
  return (
    <Dropdown id="searcherDropDown">
      <Dropdown.Toggle disabled={loading} variant="primary" id="dropdown-sort">
        <Icon name="search" />
        <span className="mx-1">{title}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu align={'end'}>
        {displaySearchFields?.map((m) => (
          <Dropdown.Item onClick={() => onMenuClick(m)} active={m?.name === searchField?.name} key={getDisplayName(m)}>
            {getDisplayName(m)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
